import { createAsyncThunk } from '@reduxjs/toolkit'
import { CheckoutPatientAddress } from 'components/modules/patientArea/products/types'
import nestApiService from 'services/api/nest-api-service'
import { apiErrorBody } from 'utils/apiError'
import { getOpenJwtToken } from 'utils/getOpenJwtToken'

export const createSpreeAddressId = createAsyncThunk<number, CheckoutPatientAddress>(
  'create-patient-address',
  async (formattedData, { rejectWithValue }) => {
    const token = await getOpenJwtToken()
    try {
      const response = await nestApiService.apiInstance.post('spree-address', formattedData, {
        headers: {
          Authorization: token
        }
      })

      return response.data.spreeAddressId
    } catch (error: any) {
      return rejectWithValue(apiErrorBody(error))
    }
  }
)
